import * as R from 'ramda'
import { SapKey, Selection, Selections } from '../../../../types/types'
import { contains } from 'app/app/common/ramda-utils'

const and = (...args: any[]) => R.all(Boolean, args)
const nand = R.complement(and)
const or = (...args: any[]) => R.any(Boolean, args)

export function setContractType(selections: Selections) {
  const get = (key: SapKey) => selections[key]
  const set = (key: SapKey, val: Selection) => R.assoc(key, val, selections)
  const eq = (key: SapKey, val: Selection) => R.equals(get(key), val)
  const neq = (key: SapKey, val: Selection) => !eq(key, val)
  const isNil = (key: SapKey) => get(key) == null
  const notNil = R.complement(isNil)
  const eqOrNil = (key: SapKey, val: Selection) => eq(key, val) || R.isNil(get(key))

  const oneOf = (key: SapKey, vals: Selection) => contains(get(key), Array.isArray(vals) ? vals : [])
  const notOneOf = (key: SapKey, vals: Selection) => notNil(key) && !oneOf(key, vals)

  const mbmMethod = eq('KCSM_CARE_MBM', '1')
  const hasCalloutThreshold = and(neq('KCSM_CO', '1'), nand(eqOrNil('KCSM_CO', '0'), eqOrNil('KCSM_NBR_CO_YEAR', '0')))
  const allCalloutsIncluded = and(eq('KCSM_CO', '1'), eqOrNil('KCSM_NBR_CO_YEAR', '0'))
  const hasCalloutThresholdOrAllCalloutsIncluded = or(hasCalloutThreshold, allCalloutsIncluded)

  if (R.isNil(selections) || R.isEmpty(selections)) {
    return selections
  }
  if (and(mbmMethod, eqOrNil('KCSM_CO', '0'), eqOrNil('KCSM_NBR_CO_YEAR', '0'), eqOrNil('KCSM_SR_ONDEMAND', '0'))) {
    return set('KCSM_KCC_CONTRACT_TYPE', '11')
  }
  if (and(mbmMethod, hasCalloutThresholdOrAllCalloutsIncluded, eq('KCSM_SR_ONDEMAND', '0'))) {
    return set('KCSM_KCC_CONTRACT_TYPE', '12')
  }
  if (and(mbmMethod, hasCalloutThresholdOrAllCalloutsIncluded, eq('KCSM_SR_ONDEMAND', '6'))) {
    return set('KCSM_KCC_CONTRACT_TYPE', '14')
  }
  if (
    and(mbmMethod, hasCalloutThresholdOrAllCalloutsIncluded, notOneOf('KCSM_SR_ONDEMAND', ['0', '1', 'NA', '6', '7']))
  ) {
    return set('KCSM_KCC_CONTRACT_TYPE', '13')
  }
  if (and(mbmMethod, hasCalloutThresholdOrAllCalloutsIncluded, oneOf('KCSM_SR_ONDEMAND', ['1', '7']))) {
    return set('KCSM_KCC_CONTRACT_TYPE', '15')
  }
  return set('KCSM_KCC_CONTRACT_TYPE', null)
}
